import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
var BUTTON_WIDTH = 20;
var PADDING_BLOCK_END = 16;
var TOPIC_INLINE_SPACE = 8;
export var useTopicBreakElems = function useTopicBreakElems(wrapperRef, showTopics) {
  var _useState = useState(-1),
    _useState2 = _slicedToArray(_useState, 2),
    breakElems = _useState2[0],
    setBreakElems = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    topicLengths = _useState4[0],
    setTopicLengths = _useState4[1];
  useEffect(function () {
    var observer = new ResizeObserver(function (topics) {
      var wrapper = topics[0];
      var cwidth = wrapper.target.clientWidth;
      var tl = topicLengths;
      var runningWidth = 0;
      var elemsHold = 0;

      // on first run, all topics are displayed so we can loop through and get the lengths
      if (tl.length === 0) {
        for (var _i = 0, _Array$from = Array.from(wrapper.target.children); _i < _Array$from.length; _i++) {
          var topic = _Array$from[_i];
          var width = topic.scrollWidth;
          tl.push(width);
        }
      }
      for (var i = 0; i < tl.length; i++) {
        var _width = topicLengths[i];
        if (runningWidth + _width + PADDING_BLOCK_END + BUTTON_WIDTH <= cwidth) {
          elemsHold += 1;
        }
        runningWidth += _width + TOPIC_INLINE_SPACE;
      }
      setBreakElems(elemsHold);
      // on first run, save the topic lengths so we can reuse
      if (topicLengths.length === 0) {
        setTopicLengths(tl);
      }
    });
    if (wrapperRef.current) {
      observer.observe(wrapperRef.current);
    }
    return function () {
      observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showTopics]);
  return {
    breakElems: breakElems
  };
};